export const actions = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  REDIRECT: 'REDIRECT',
};
